import React, { useEffect, useState } from 'react'
import ServiceProviders from './setupType/ServiceProviders'

export default function FacilityMessagingSetupType({ title, description, navigation, errors, setValue, values }) {
    const [mode, setMode] = useState()
    const [name, setName] = useState()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        title('Messaging Service Providers')
        description('Select or create a new service provider')
        navigation([
            // {
            //     text: 'Back', type: 'Back', action: async () => { }
            // },
            // { text: 'Next', disabled: true, type: 'Next', action: async () => { } }
        ])


        // _loadSettings()
    }, [])

    useEffect(() => {
        // if (values.name && values.serviceType) {
        //     navigation([{ text: 'Next', type: 'Next', action: async () => { } }]);
        //     return;
        // }    

        // navigation([{ text: 'Next', type: 'Next', disabled: true }])
    },
        [values]
    )
    // useEffect(() => { navigation([{ text: 'Next', type: 'Next', disabled: true }]) }, [mode])

    return (
        <div>
            <ServiceProviders errors={errors} setValue={setValue} values={values} />
        </div>
    )
}
